export const GET_ROLES = 'GET_ROLES';
export const GET_ROLE_BY_ID = 'GET_ROLE_BY_ID';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const CREATE_ROLE = 'CREATE_ROLE';
